import { DataGrid, GridActionsColDef, GridColDef, GridDensity, GridPaginationInitialState } from "@mui/x-data-grid";
import { ComponentProps } from "../types";
import { CSSProperties, useMemo, useContext } from "react";
import DashboardComponent from "./DashboardComponent";
import DashboardPageContext from "../DashboardPageContext";
import DataGridRowContext from "./DataGridRowContext";
import ExecutionTypeContext, { Mode } from "../ExecutionTypeContext";
import { Box } from "@mui/material";
import { GridInitialStateCommunity } from "@mui/x-data-grid/models/gridStateCommunity";

function Component({ component, evaluteScript }: ComponentProps) {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const { context, params, updateContext } = useContext(DashboardPageContext);
	const exeMode = useContext(ExecutionTypeContext);

	const style = useMemo(() => {
		const style = {} as CSSProperties;
		if (exeMode?.mode === Mode.DESIGN && component.id === exeMode?.activeComponent?.id) style.border = "1px dashed red";
		style.height = "100%";
		return style;
	}, [component, exeMode]);

	const boxArgs = useMemo(() => {
		const args = {} as { [key: string]: unknown };
		return args;
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [component, context]);

	const initialState = useMemo(() => {
		const columns = [] as (GridColDef | GridActionsColDef)[];
		if (component.childern) {
			component.childern
				.filter((c) => c.type === "DataGridColumn" && c.properties["field"])
				.forEach((col) => {
					const colDef = {
						field: col.properties["field"],
						headerName: col.properties["headerName"] || undefined,
						width: col.properties["width"] ? col.properties["width"] : undefined,
						flex: col.properties["flex"] ? parseInt(col.properties["flex"]) : undefined,
						headerAlign: col.properties["headerAlign"] || undefined,
						align: col.properties["align"] || undefined,
						type: col.properties["type"] || "singleSelect",
						sortable: (col.properties["sortable"] || "True") === "True" ? true : false,
					} as GridColDef;
					columns.push(colDef);
				});
			const actions = component.childern.filter((c) => (c.type === "DataGridActionColumn" || c.type === "DataGridNavColumn") && c.properties["icon"]);
			if (actions.length > 0)
				columns.push({
					field: "actions",
					type: "actions",
					width: actions.length * 50,
					getActions: ({ row }) => actions.map((action) => <DataGridRowContext.Provider value={row}>{(!action.properties["displayCondition"] || (evaluteScript(action.properties["displayCondition"]) as boolean)) && <DashboardComponent component={action} />}</DataGridRowContext.Provider>),
				} as GridActionsColDef);
		}

		let rows: Record<string, string>[] | undefined = undefined;
		rows = evaluteScript(component.properties["rows"]) as Record<string, string>[] | [];
		return {
			rows: rows === null || !Array.isArray(rows) ? [] : rows,
			columns: columns,
			initialState: {
				pagination: {
					pageSize: parseInt(component.properties["pageSize"] || "3"),
				} as GridPaginationInitialState,
			} as GridInitialStateCommunity,
			pageSizeOptions: [parseInt(component.properties["pageSize"] || "3")] as Array<number>,
			checkboxSelection: false,
			disableColumnMenu: true,
			disableColumnFilter: true,
			disableRowSelectionOnClick: true,
			rowSelection: false,
			autoHeight: (component.properties["autoHeight"] || "True") === "True" ? true : false,
			density: (component.properties["density"] || "standard") as GridDensity,
			rowHeight: parseInt(component.properties["rowHeight"] || "52"),
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [component, context]);

	const locatorArgs = useMemo(() => {
		const args = {} as { [key: string]: unknown };
		if (exeMode?.mode === Mode.DESIGN && exeMode.locatorActivated === true) {
			args["onClick"] = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
				if (exeMode.updateActiveComponent) exeMode.updateActiveComponent(component);
				event.stopPropagation();
			};
		}
		return args;
	}, [component, exeMode]);

	return (
		<Box style={style} {...boxArgs} {...locatorArgs}>
			<DataGrid
				initialState={initialState.initialState}
				rows={initialState.rows}
				columns={initialState.columns}
				checkboxSelection={initialState.checkboxSelection}
				disableColumnMenu={initialState.disableColumnMenu}
				disableColumnFilter={initialState.disableColumnFilter}
				//@ts-ignore
				disableSelectionOnClick={initialState.disableRowSelectionOnClick}
				autoHeight={initialState.autoHeight}
				density={initialState.density}
				rowHeight={initialState.rowHeight}
				rowsPerPageOptions={initialState.pageSizeOptions}
			></DataGrid>
		</Box>
	);
}

export default Component;
